import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductosService } from 'src/app/services/productos.service';
import { ProductI } from 'src/app/shared/producto.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-editar-producto',
  templateUrl: './editar-producto.component.html',
  styleUrls: ['./editar-producto.component.scss']
})
export class EditarProductoComponent implements OnInit {

  prodId: string;
  producto: ProductI;
  imageSrc: any;
  image: any;
  private imageOriginal: any;
  imgLoad = false;
  constructor(private prodSvc: ProductosService,
              private route: ActivatedRoute,
              private router: Router) { }

  editProductForm = new FormGroup({
    nombre: new FormControl('', Validators.required),
    categoria: new FormControl('', Validators.required),
    fechaCreacion: new FormControl(new Date().getTime()),
    imageProd: new FormControl('', Validators.required),
    descripcion: new FormControl(''),
    precio: new FormControl(''),
    amarillo: new FormControl(''),
    gris: new FormControl(''),
    azul: new FormControl(''),
    verde: new FormControl(''),
    rojo: new FormControl(''),
    negro: new FormControl(''),
    blanco: new FormControl(''),
    gr1000: new FormControl(''),
    gr1500: new FormControl(''),
    lt1: new FormControl(''),
    ltvalvula: new FormControl(''),
    ltrPist: new FormControl(''),
    ltrPistRep: new FormControl(''),
    ltr38: new FormControl(''),
    lt5: new FormControl(''),
    kg4: new FormControl(''),
    kg22: new FormControl(''),
    lt20: new FormControl(''),
    kg1: new FormControl(''),
    kg44: new FormControl(''),
    kg21: new FormControl(''),
    kiwi: new FormControl(''),
    sinAroma: new FormControl(''),
    citronela: new FormControl(''),
    floral: new FormControl(''),
    limon: new FormControl(''),
    lavanda: new FormControl(''),
    vinagre: new FormControl(''),
    frutosRojos: new FormControl(''),
    tL: new FormControl(''),
    tM: new FormControl(''),
    tS: new FormControl(''),
  });

  private initValuesForm(){
    this.editProductForm.patchValue({
      id: this.producto.id,
      nombre: this.producto.nombre,
      categoria: this.producto.categoria,
      fechaCreacion: this.producto.fechaCreacion,
      descripcion: this.producto.descripcion,
      precio: this.producto.precio,
      amarillo: this.producto.amarillo,
      gris: this.producto.gris,
      azul: this.producto.azul,
      verde: this.producto.verde,
      rojo: this.producto.rojo,
      negro: this.producto.negro,
      blanco: this.producto.blanco,
      gr1000: this.producto.gr1000,
      gr1500: this.producto.gr1500,
      lt1: this.producto.lt1,
      ltvalvula: this.producto.ltvalvula,
      ltrPist: this.producto.ltrPist,
      ltrPistRep: this.producto.ltrPistRep,
      ltr38: this.producto.ltr38,
      lt5: this.producto.lt5,
      kg4: this.producto.kg4,
      kg22: this.producto.kg22,
      lt20: this.producto.lt20,
      kg1: this.producto.kg1,
      kg44: this.producto.kg44,
      kg21: this.producto.kg21,
      kiwi: this.producto.kiwi,
      sinAroma: this.producto.sinAroma,
      citronela: this.producto.citronela,
      floral: this.producto.floral,
      limon: this.producto.limon,
      lavanda: this.producto.lavanda,
      vinagre: this.producto.vinagre,
      frutosRojos: this.producto.frutosRojos,
      tL: this.producto.tL,
      tM: this.producto.tM,
      tS: this.producto.tS
    });
  }

  get nombreNoValido() {
    return this.editProductForm.get('nombre').invalid && this.editProductForm.get('nombre').touched;
  }
  get categoriaNoValido() {
    return this.editProductForm.get('categoria').invalid && this.editProductForm.get('categoria').touched;
  }


  ngOnInit(): void {
    this.prodId = this.route.snapshot.paramMap.get('id');
    this.prodSvc.getProductById(this.prodId)
                    .subscribe((resp: ProductI) => {
                      this.producto = resp;
                      this.producto.id = this.prodId;
                      this.image = this.producto.imageProd;
                      this.imageOriginal = this.producto.imageProd;
                      this.imageSrc = this.producto.imageProd;
                      // console.log('Producto: ', this.producto);
                      this.initValuesForm();
                    });
  }

  addNewEditProduct(prd: any){
    prd.id = this.prodId;
    // console.log(prd);
    if (this.image === this.imageOriginal) {
      prd.imageProd = this.imageOriginal;
      this.prodSvc.updateProductById(prd).then(() => {
        Swal.fire('Actualizado!', 'El producto ha sido editado.', 'success');
        this.router.navigate(['/GestionProductos']);
      });
    } else {
      this.prodSvc.updateProductById(prd, this.image);
      Swal.fire('Actualizado!', 'El producto ha sido editado.', 'success');
      this.router.navigate(['/GestionProductos']);
    }
  }

  handleImage(event: any){
    this.image = event.target.files[0];
    const reader = new FileReader();
    reader.onload = e => {
      this.imageSrc = reader.result;
    };
    reader.readAsDataURL(this.image);
  }


}
